angular.module 'zc.projects'

.directive 'projectsMenu', ($state, $stateParams, $timeout, Project) ->
  directive =
    restrict: "EA"
    scope: {}
    replace: true
    templateUrl: '/templates/projects/views/directives/projects_menu.html'
    link: (scope, element) ->
      scope.Project = Project
      scope.projects = []
      
      Project.getCurrent($stateParams.projectId).then (res) ->
        scope.currentProject = res
      Project.all().then (projects) ->
        scope.projects = _.sortBy projects, (project) ->
          project.title.toLowerCase()
        
      scope.$watch 'Project.currentProject', (newVal, oldVal) ->
        scope.currentProject = newVal

    controller: ($rootScope) ->
      $rootScope.$on '$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
        if toState
          if toParams.projectId
            Project.get(toParams.projectId)
            .then (project) ->
              Project.currentProject = project
          else
            Project.currentProject = undefined


  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/projects_menu.js.coffee